import type { ReactNode } from "react";
import "./ScheduleToolbar.scss";
import SwitchScheduleAnalysis, {
  type ScheduleOrAnalysis,
} from "@/pages/human-resources/time-management/components/switch-schedule-analysis/SwitchScheduleAnalysis.tsx";
import SwitchViewRange from "@/pages/human-resources/time-management/components/switch-view-range/SwitchViewRange.tsx";
import ScheduleDateNavigator from "@/pages/human-resources/time-management/components/date-navigator/ScheduleDateNavigator.tsx";
import ScheduleToolbarButtons from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/buttons/ScheduleToolbarButtons.tsx";
import { parseIsoDate } from "@/shared/utils/Dates.ts";
import useScheduleViewFilters from "@/pages/human-resources/time-management/components/display-filters/provider/useScheduleViewFilters.ts";
import { LEGACY_TIME_ZONE } from "@/shared/utils/LegacyDates.ts";
import { useRouteParam } from "@/shared/routing/useRouteParam.ts";
import useScheduleUrls from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/useScheduleUrls.ts";
import { useNavigate } from "react-router-dom";
import useScheduleRangeOnRoute from "@/pages/human-resources/time-management/hooks/useScheduleRangeOnRoute.ts";
import LastScheduleModification from "@/pages/human-resources/time-management/components/last-schedule-modification/LastScheduleModification.tsx";
import { DateTime } from "luxon";

interface Properties {
  viewType: ScheduleOrAnalysis;
}

export default function ScheduleToolbar(props: Properties): ReactNode {
  const currentRange = useScheduleRangeOnRoute();
  const {
    state: { viewArrangement },
  } = useScheduleViewFilters();
  const isClassicView = viewArrangement !== "position";
  const showToolbarButtons = isClassicView && props.viewType === "schedule";
  const scheduleDate = parseIsoDate(useRouteParam("date"), LEGACY_TIME_ZONE);
  const scheduleRange = useScheduleRangeOnRoute();
  const scheduleUrls = useScheduleUrls(props.viewType);
  const navigate = useNavigate();

  return (
    <div className="schedule-toolbar">
      <div className="left-switches">
        <SwitchScheduleAnalysis value={props.viewType} />
        {isClassicView && <SwitchViewRange viewType={props.viewType} />}
      </div>
      <div className="center">
        <ScheduleDateNavigator
          timeZone={LEGACY_TIME_ZONE}
          viewRange={scheduleRange}
          value={DateTime.fromJSDate(scheduleDate)}
          onChange={(d) => {
            void navigate(scheduleUrls.toDate(d.toJSDate()));
          }}
        />
        {props.viewType === "schedule" && <LastScheduleModification />}
      </div>
      {showToolbarButtons ?
        <ScheduleToolbarButtons showEvents={currentRange === "DAY"} />
      : <div className="buttons-placeholder" />}
    </div>
  );
}
